import {
	Box,
	InputLabel,
	MenuItem,
	Select,
	Stack,
	TextareaAutosize,
	TextField,
	Typography,
} from '@mui/material';
import React, { Dispatch, SetStateAction } from 'react';
import { useGlobalState } from '../../../../stateProviders/GlobalStateProvider.tsx';
import EmergencyIcon from '@mui/icons-material/Emergency';

import Accessory from 'src/types/shared/accessory';

const AccessoryDataCard: React.FC<{
	accessoryData: Accessory;
	setAccessoryData: Dispatch<SetStateAction<Accessory>>;
	calculationTypes: string[];
}> = ({ accessoryData, setAccessoryData, calculationTypes }) => {
	const globalState = useGlobalState();
	return (
		<Box
			sx={{
				marginTop: '20px',
				borderRadius: '10px',
				padding: '10px',
				border: '1px solid #E5E7EB',
			}}
		>
			<Typography sx={{ marginBottom: '15px' }}>
				Accessory Information
			</Typography>

			<Stack display="grid" gridTemplateColumns="1fr 1fr" gap={2} sx={{}}>
				<Box>
					<InputLabel
						id="accessory-name-label"
						sx={{ fontSize: '12px', color: 'gray.500', marginBottom: '5px' }}
					>
						Accessory Name
						<EmergencyIcon
							sx={{
								color: 'orangeRed',
								fontSize: '8px',
								marginLeft: '5px',
							}}
						/>
					</InputLabel>

					<TextField
						value={accessoryData.name}
						onChange={(e) =>
							setAccessoryData((prev) => ({ ...prev, name: e.target.value }))
						}
					/>
				</Box>

				<Box>
					<InputLabel
						id="calculation-type-label"
						sx={{ fontSize: '12px', color: 'gray.500', marginBottom: '5px' }}
					>
						Unit Calculation Method
						<EmergencyIcon
							sx={{
								color: 'orangeRed',
								fontSize: '8px',
								marginLeft: '5px',
							}}
						/>
					</InputLabel>

					<Select
						labelId="calculation-type-label"
						value={accessoryData.calculationType}
						fullWidth
						onChange={(e) =>
							setAccessoryData((prev) => ({
								...prev,
								calculationType: e.target.value,
							}))
						}
						sx={{
							border: '1px solid #E5E7EB',
						}}
					>
						{calculationTypes.map((calculationType) => (
							<MenuItem key={calculationType} value={calculationType}>
								{calculationType}
							</MenuItem>
						))}
					</Select>
				</Box>
			</Stack>

			<Box
				sx={{
					marginTop: '20px',
				}}
			>
				<InputLabel
					id="accessory-desc-label"
					sx={{ fontSize: '12px', color: 'gray.500', marginBottom: '5px' }}
				>
					Description
				</InputLabel>

				{globalState.company?.isDocubeeTenant && (
					<Typography
						sx={{
							fontSize: '11px',
							color: 'gray.600',
							marginBottom: '8px',
							fontStyle: 'italic',
						}}
					>
						Description below will appear in your contract
					</Typography>
				)}

				<TextareaAutosize
					value={accessoryData.description}
					minRows={3}
					maxRows={3}
					style={{
						width: '100%',
						border: '1px solid #E5E7EB',
						borderRadius: '10px',
						padding: '5px',
						outline: '0px',
					}}
					placeholder="Description ..."
					onChange={(e) => {
						setAccessoryData((prev) => ({
							...prev,
							description: e.target.value,
						}));
					}}
				/>
			</Box>
		</Box>
	);
};

export default AccessoryDataCard;
